"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MfaChannelsToJSON = exports.MfaChannelsFromJSONTyped = exports.MfaChannelsFromJSON = void 0;
const _1 = require("./");
function MfaChannelsFromJSON(json) {
    return MfaChannelsFromJSONTyped(json, false);
}
exports.MfaChannelsFromJSON = MfaChannelsFromJSON;
function MfaChannelsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'channels': (json['channels'].map(_1.MfaChannelsChannelsFromJSON)),
    };
}
exports.MfaChannelsFromJSONTyped = MfaChannelsFromJSONTyped;
function MfaChannelsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'channels': (value.channels.map(_1.MfaChannelsChannelsToJSON)),
    };
}
exports.MfaChannelsToJSON = MfaChannelsToJSON;
//# sourceMappingURL=MfaChannels.js.map